(function() {
  'use strict';
  angular
    .module('servicetracker', [
      'ngSanitize',
      'ngAria',
      'ui.router',
      'ui.bootstrap',
      'toastr',
      'ngMap',
      'formio',
      'ngFormioHelper'
    ])
    .factory('Geolocation', Geolocation);

  /** @ngInject */
  function Geolocation($q, $window) {
    return {
      getCurrentPosition: function() {
        var deferred = $q.defer();

        if (!$window.navigator.geolocation) {
          return deferred.reject('Geolocation not supported.');
        }

        $window.navigator.geolocation.getCurrentPosition(
          function(position) {
            deferred.resolve(position);
          },
          function(err) {
            deferred.reject(err);
          }
        );

        return deferred.promise;
      }
    };
  }
})();

angular.module('servicetracker')
  .provider('TimeClockResource', function() {
    return {
      $get: function() { return null; },
      parent: 'appointment',
      base: 'dealer.customer.appointment.',
      templates: {
        view: 'views/timeclock/view.html'
      },
      controllers: {
        create: ['$scope', 'Geolocation', function($scope, Geolocation) {
          Geolocation.getCurrentPosition()
            .then(function(data) {
              if (!data || !data.coords || !data.coords.longitude || !data.coords.latitude) return;
              $scope.submission.data.location = [data.coords.latitude, data.coords.longitude];
            })
            .catch(function() {
              $scope.submission.data.location = [0, 0];
            });
        }]
      }
    };
  });

angular.module('servicetracker')
  .provider('ServiceResource', function() {
    return {
      $get: function() { return null; },
      parent: 'appointment',
      base: 'dealer.customer.appointment.',
      templates: {
        view: 'views/service/view.html'
      }
    };
  });

angular.module('servicetracker')
  .provider('EquipmentResource', function() {
    return {
      $get: function() { return null; },
      parent: 'customer',
      base: 'dealer.customer.',
      templates: {
        view: 'views/equipment/view.html'
      }
    };
  });

angular.module('servicetracker')
  .provider('DealerResource', function() {
    return {
      $get: function() { return null; },
      templates: {
        abstract: 'views/dealer/dealer.html',
        view: 'views/dealer/view.html'
      }
    };
  });

angular.module('servicetracker')
  .provider('CustomerResource', function() {
    return {
      $get: function() { return null; },
      parent: 'dealer',
      base: 'dealer.',
      templates: {
        abstract: 'views/customer/customer.html',
        view: 'views/customer/view.html'
      },
      controllers: {
        view: ['$scope', function($scope) {
          $scope.position = {lat: '40.74', lng: '-74.18'};
          $scope.customer.loadSubmissionPromise.then(function(customer) {
            if (
              customer.data.address &&
              customer.data.address.geometry &&
              customer.data.address.geometry.location
            ) {
              $scope.position.lat = customer.data.address.geometry.location.lat;
              $scope.position.lng = customer.data.address.geometry.location.lng;
            }
          });
        }]
      }
    };
  });

angular.module('servicetracker')
  .provider('ContractorResource', function() {
    return {
      $get: function() { return null; },
      parent: 'dealer',
      base: 'dealer.'
    };
  });

angular.module('servicetracker')
  .provider('AppointmentResource', function() {
    return {
      $get: function() { return null; },
      parent: 'customer',
      base: 'dealer.customer.',
      templates: {
        abstract: 'views/appointment/appointment.html',
        view: 'views/appointment/view.html'
      }
    };
  });

(function() {
  'use strict';

  angular
    .module('servicetracker')
    .run(runBlock);

  /** @ngInject */
  function runBlock(
    $log,
    $rootScope,
    AppConfig,
    FormioAuth
  ) {
    // Initialize the Form.io authentication system.
    FormioAuth.init();

    // Allow the app to have access to configurations.
    $rootScope.config = AppConfig;

    // Add the forms to the root scope.
    angular.forEach(AppConfig.forms, function(url, form) {
      $rootScope[form] = url;
    });

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('servicetracker')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig(
    $stateProvider,
    $urlRouterProvider,
    FormioResourceProvider,
    FormioFormsProvider,
    AppConfig,
    $injector
  ) {
    $stateProvider
      .state('home', {
        url: '/?',
        templateUrl: 'views/home.html'
      })
      .state('appointments', {
        url: '/appointments',
        templateUrl: 'views/appointment/all.html',
        controllerAs: 'appointments',
        controller: ['$scope', '$state', '$rootScope', function($scope, $state, $rootScope) {
          $scope.$on('rowView', function(event, appointment) {
            $state.go('dealer.customer.appointment.view', {
              dealerId: $rootScope.user.data.dealer._id,
              customerId: appointment.data.customer._id,
              appointmentId: appointment._id
            });
          });
        }]
      });

    // Register all of the resources.
    angular.forEach(AppConfig.resources, function(resource, name) {
      FormioResourceProvider.register(name, resource.form, $injector.get(resource.resource + 'Provider'));
    });

    // Register the form provider for the customer.
    FormioFormsProvider.register('customer', AppConfig.appUrl, {
      field: [{
        name: 'customer',
        stateParam: 'customerId'
      }],
      base: 'dealer.customer.',
      tag: 'customer'
    });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('servicetracker')
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('servicetracker')
    .config(config);

  /** @ngInject */
  function config(
    toastrConfig,
    FormioProvider,
    FormioAuthProvider,
    AppConfig,
    $locationProvider
  ) {
    $locationProvider.hashPrefix('');

    // Set the base url for formio.
    FormioProvider.setBaseUrl(AppConfig.apiUrl);
    FormioProvider.setAppUrl(AppConfig.appUrl);

    // Initialize our FormioAuth provider states.
    FormioAuthProvider.setStates('auth.login', 'home');
    FormioAuthProvider.setForceAuth(true);
    FormioAuthProvider.register('login', 'user');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }
})();
